export default __webpack_public_path__ + "static/media/lisieux01min.599a9584.jpg";